import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initPWADiagnostics } from "./lib/pwaDiagnostics";
import { isSupabaseConfigured } from "./integrations/supabase/client";
import App from "./App.tsx";
import { MaintenanceScreen } from "./components/MaintenanceScreen";
import "./index.css";
import "./i18n/i18n";
// Lazy-load PostHog to reduce initial bundle size / improve TTI
if (typeof window !== 'undefined' && import.meta.env.VITE_POSTHOG_KEY) {
  import('posthog-js').then(({ default: posthog }) => {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
      person_profiles: 'identified_only',
      autocapture: false,
      disable_session_recording: true,
      capture_pageview: false,
    });
  });
}

// Initialize PWA diagnostics early
initPWADiagnostics();

// Check if we just updated and show notification after React mounts
const justUpdated = sessionStorage.getItem('app-just-updated');
if (justUpdated) {
  sessionStorage.removeItem('app-just-updated');
  // Dispatch event after a short delay to ensure toast system is ready
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('app-updated'));
  }, 500);
}

import { initPWA } from "./pwa";

// Initialize PWA logic
initPWA();

// Hide the initial HTML loader
if (typeof window !== 'undefined' && (window as any).hideInitialLoader) {
  (window as any).hideInitialLoader();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isSupabaseConfigured ? <App /> : <MaintenanceScreen />}
  </StrictMode>
);
